module.exports = __webpack_public_path__ + "media/images/favicon-8e45e676741cae2fc5e3a10fe04f28fe.svg";